export default __webpack_public_path__ + "static/media/product-detail-02.f101e240.jpg";